export default __webpack_public_path__ + "static/media/femimed_pokoj_przygotowawczy_1.8e844cdc.webp";